import Vue from "vue";
import Vuex from "vuex";
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
// import data from '../assets/dbdata.json';
// import { getField, updateField } from 'vuex-map-fields';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // data: [] = data
    data: []
  },
  mutations,
  actions,
  getters,
});



// WEBPACK FOOTER //
// ./src/store/index.js